<template>
  <nav class="px-0">
    <div
      class="nav nav-tabs mes-tabs mes-qc-insp-tabs"
      id="nav-tab"
      role="tablist"
    >
      <button
        class="nav-link mes-tab mes-qc-insp-tab"
        :class="{ active: tabIndex == 0 }"
        id="nav-inspection-heat-tab"
        data-bs-toggle="tab"
        data-bs-target="#nav-inspection-heat"
        type="button"
        role="tab"
        aria-controls="nav-inspection-heat"
        aria-selected="true"
        @click="tabIndex = 0"
      >
        外觀檢驗_熱處理
      </button>
      <button
        class="nav-link mes-tab mes-qc-insp-tab"
        :class="{ active: tabIndex == 1 }"
        id="nav-inspection-surface-tab"
        data-bs-toggle="tab"
        data-bs-target="#nav-inspection-surface"
        type="button"
        role="tab"
        aria-controls="nav-inspection-surface"
        aria-selected="false"
        @click="tabIndex = 1"
      >
        外觀檢驗_表面處理
      </button>
      <button
        class="nav-link mes-tab mes-qc-insp-tab"
        :class="{ active: tabIndex == 2 }"
        id="nav-inspection-mechanical-tab"
        data-bs-toggle="tab"
        data-bs-target="#nav-inspection-mechanical"
        type="button"
        role="tab"
        aria-controls="nav-inspection-mechanical"
        aria-selected="false"
        @click="tabIndex = 2"
      >
        機械性質檢驗
      </button>
    </div>
  </nav>
  <div class="tab-content inspectionList-tab-content pb-2" id="nav-tabContent">
    <div
      class="tab-pane fade"
      :class="{
        'show active': tabIndex == 0,
      }"
      id="nav-inspection-heat"
      role="tabpanel"
      aria-labelledby="nav-inspection-heat-tab"
    >
      <div class="row mx-0">
        <div class="col-12" style="height: 2.5rem"></div>
        <template v-if="inspectionData.heat.length === 0">
          <div class="col-12 mt-3 text-start">
            <span>第1支工件</span>
            <commonTable
              :fields="inspectionFields"
              :items="[]"
              :tableClass="'text-center'"
              stickyHeader="179px"
            />
          </div>
          <div class="col-12 mt-3 text-start">
            <span>第2支工件</span>
            <commonTable
              :fields="inspectionFields"
              :items="[]"
              :tableClass="'text-center'"
              stickyHeader="179px"
            />
          </div>
        </template>
        <template v-else>
          <template
            v-for="(inspectionValue, nth) in inspectionData.heat"
            :keys="nth"
          >
            <template v-for="(list, count) in inspectionValue" :keys="count">
              <div class="col-12 mt-3 text-start">
                <span>第{{ count + 1 }}支工件</span>
                <commonTable
                  :fields="inspectionFields"
                  :items="list.inspection"
                  :tableClass="'text-center'"
                  stickyHeader="179px"
                >
                  <template #cell(time)="row">
                    {{ row.value.split(".")[0] }}
                  </template>
                </commonTable>
              </div>
            </template>
          </template>
        </template>
      </div>
    </div>
    <div
      class="tab-pane fade"
      :class="{
        'show active': tabIndex == 1,
      }"
      id="nav-inspection-surface"
      role="tabpanel"
      aria-labelledby="nav-inspection-surface-tab"
    >
      <div class="row mx-0">
        <div class="col-12" style="height: 2.5rem"></div>
        <template v-if="inspectionData.surface.length === 0">
          <div class="col-12" style="height: 2.5rem"></div>
          <div class="col-12 mt-3 text-start">
            <span>第1支工件</span>
            <commonTable
              :fields="inspectionFields"
              :items="[]"
              :tableClass="'text-center'"
              stickyHeader="179px"
            />
          </div>
          <div class="col-12 mt-3 text-start">
            <span>第2支工件</span>
            <commonTable
              :fields="inspectionFields"
              :items="[]"
              :tableClass="'text-center'"
              stickyHeader="179px"
            />
          </div>
        </template>
        <template v-else>
          <template
            v-for="(inspectionValue, nth) in inspectionData.surface"
            :keys="nth"
          >
            <template v-for="(list, count) in inspectionValue" :keys="count">
              <div class="col-12 mt-3 text-start">
                <span>第{{ count + 1 }}支工件</span>
                <commonTable
                  :fields="inspectionFields"
                  :items="list.inspection"
                  :tableClass="'text-center'"
                  stickyHeader="179px"
                >
                  <template #cell(time)="row">
                    {{ row.value.split(".")[0] }}
                  </template>
                </commonTable>
              </div>
            </template>
          </template>
        </template>
      </div>
    </div>
    <div
      class="tab-pane fade"
      :class="{
        'show active': tabIndex == 2,
      }"
      id="nav-inspection-mechanical"
      role="tabpanel"
      aria-labelledby="nav-inspection-mechanical-tab"
    >
      <div class="row mx-0">
        <div class="col-12" style="height: 2.5rem"></div>
        <template v-if="inspectionData.mechanical.length === 0">
          <div class="col-12 mt-3 text-start">
            <span>第1支工件</span>
            <commonTable
              :fields="inspectionFields"
              :items="[]"
              :tableClass="'text-center'"
              stickyHeader="179px"
            />
          </div>
          <div class="col-12 mt-3 text-start">
            <span>第2支工件</span>
            <commonTable
              :fields="inspectionFields"
              :items="[]"
              :tableClass="'text-center'"
              stickyHeader="179px"
            />
          </div>
        </template>
        <template v-else>
          <template
            v-for="(inspectionValue, nth) in inspectionData.mechanical"
            :keys="nth"
          >
            <template v-for="(list, count) in inspectionValue" :keys="count">
              <div class="col-12 mt-3 text-start">
                <commonTable
                  :fields="machInspectionFields"
                  :items="list.inspection"
                  :tableClass="'text-center'"
                  stickyHeader="179px"
                >
                  <template #cell(time)="row">
                    {{ row.value.split(".")[0] }}
                  </template>
                </commonTable>
              </div>
            </template>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "@vue/runtime-core";
import commonTable from "@/components/commonTable.vue";
export default {
  props: {
    inspectionData: Object,
  },
  components: {
    commonTable,
  },
  setup() {
    const tabIndex = ref(0);
    const button_select = ref(1);
    const inspectionFields = [
      {
        key: "time",
        label: "檢驗時間",
        thStyle: {
          "min-width": "180px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "inspector",
        label: "檢測人員",
        thStyle: {
          "min-width": "80px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "code",
        label: "檢驗項目",
        thStyle: {
          "min-width": "80px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "standardValue",
        label: "標準值",
        thStyle: {
          "min-width": "115px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "inspectionValue",
        label: "檢驗值",
        thStyle: {
          "min-width": "80px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "result",
        label: "檢驗結果",
        thStyle: {
          "min-width": "80px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const machInspectionFields = [
      {
        key: "time",
        label: "檢驗時間",
        thStyle: {
          "min-width": "180px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "inspector",
        label: "檢測人員",
        thStyle: {
          "min-width": "80px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "code",
        label: "檢驗項目",
        thStyle: {
          "min-width": "80px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "standardValue",
        label: "標準值",
        thStyle: {
          "min-width": "115px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "inspectionValue1",
        label: "抽樣檢驗值",
        thStyle: {
          "min-width": "85px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "inspectionValue2",
        label: "抽樣檢驗值",
        thStyle: {
          "min-width": "85px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "inspectionValue3",
        label: "抽樣檢驗值",
        thStyle: {
          "min-width": "85px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "result",
        label: "檢驗結果",
        thStyle: {
          "min-width": "80px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    return { tabIndex, button_select, inspectionFields, machInspectionFields };
  },
};
</script>

<style>
.inspectionList-tab-content {
  background-color: var(--main-font-color);
}
.inspectionList-btn {
  height: 2rem;
  padding: 0;
  width: 4.25rem;
  color: var(--main-font-color);
  background-color: var(--main-status-secondary-color);
  border-color: var(--main-status-secondary-color);
}
.inspectionList-btn:hover {
  color: var(--main-font-color);
}
.inspectionList-btn.active {
  background-color: var(--main-bg-color);
  border-color: var(--main-bg-color);
}
.mes-tab.mes-qc-insp-tab {
  width: 170px;
}
</style>
